module.exports = __webpack_public_path__ + "73f9a0ede528882146ea4bfe2ae935b5.svg";